import React from 'react';
import styled from 'styled-components';
import GridTemplateColumns from './GridTemplateColumns';
import ProcedureHeaderSortButton from './ProcedureHeaderSortButton';

const SubHeader = styled.div`
padding-top:15px;
display:grid;
grid-template-columns:${GridTemplateColumns};
;
padding-left:10px;
padding-right:10px;
padding-bottom:15px;

`;

const SubHeaderText = styled.div`
color: gray;
font-family: Roboto;
font-size: 14px;
font-weight: 500;
line-height: 19px;
text-align: left;
`;

const ProceduresListHeader = props => {

    return (

        <SubHeader>
            <div />
            <ProcedureHeaderSortButton property={'sdn'}>*SDN</ProcedureHeaderSortButton>
            <ProcedureHeaderSortButton property={'name'}>*Title</ProcedureHeaderSortButton>
            <ProcedureHeaderSortButton property={'categoryName'}>*Category</ProcedureHeaderSortButton>
            <ProcedureHeaderSortButton property={'rev'}>*Rev</ProcedureHeaderSortButton>
            <ProcedureHeaderSortButton property={'effectiveDate'}>*Effective Date</ProcedureHeaderSortButton>
            <ProcedureHeaderSortButton property={'url'} style={{ textAlign: 'center' }}>*URL</ProcedureHeaderSortButton>
            <ProcedureHeaderSortButton property={'url'} style={{ textAlign: 'center' }}>Deviations</ProcedureHeaderSortButton>
            <div></div>
        </SubHeader>


    )
}

export default ProceduresListHeader;